import { render } from "./PanelNav.vue?vue&type=template&id=0f609df0&scoped=true"
import script from "./PanelNav.vue?vue&type=script&lang=js"
export * from "./PanelNav.vue?vue&type=script&lang=js"

import "./PanelNav.vue?vue&type=style&index=0&id=0f609df0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f609df0"]])

export default __exports__